import { useEffect } from 'react';

// based off https://github.com/rauldeheer/use-async-effect
export function useAsyncEffect(
  effect: (isMounted: () => boolean) => any,
  dependencies?: any[],
);
export function useAsyncEffect(
  effect: (isMounted: () => boolean) => any,
  destroy?: (result: any) => void,
  dependencies?: any[],
);
export function useAsyncEffect(
  effect: (isMounted: () => boolean) => any,
  dependenciesOrDestroy?: any[] | ((result: any) => void),
  dependencies?: any[],
) {
  const destroy =
    typeof dependenciesOrDestroy === 'function'
      ? dependenciesOrDestroy
      : undefined;

  const deps = destroy ? dependencies : (dependenciesOrDestroy as any[]);

  useEffect(() => {
    let result;
    let mounted = true;

    const maybePromise = effect(() => mounted);

    Promise.resolve(maybePromise).then(value => {
      result = value;
    });

    return () => {
      mounted = false;

      if (destroy) {
        destroy(result);
      }
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
